import {EditableSetting, SettingToUpdate} from "../../data/models/UpdatingSetting";
import * as React from "react";
import {Checkbox, InputAddon, TextInput} from "@vebox/etui-core";
import {ChangeRegister, EditConfigurationTableData} from "./types";
import {TableColumn, TABLES_INDEXES, TABLES_NAMES} from "../CurrentConfigurationTable/types";
import {createColumn, createColumnsForCurrentSettings} from "../CurrentConfigurationTable/utils";
import "./styles.scss"
import {getFormattedDate, getUnitOfMeasure, isUndefinedOrNullValue} from "../../ReadAndWrite/utils";
import {AppTranslations} from "../../../components/Utils/translations/AppTranslations";
import {RegisterInfo} from "../../components/RegisterInfo";

declare var AppTranslations: AppTranslations;

export const isChecked = (regNumber: number, settingsToUpdate: SettingToUpdate[]): boolean => {
    return settingsToUpdate.find((setting) => setting.reg === regNumber) !== undefined;
}

export const isDisabled = (regNumber: number, settingsToUpdate: SettingToUpdate[]): boolean => {
    return isChecked(regNumber, settingsToUpdate)
        && settingsToUpdate.find((setting) => setting.reg === regNumber).newValue !== undefined;
}

export const mapSettingsToTableData = (editableSetting: EditableSetting[],
                                       handleOnTextInputChange: ChangeRegister,
                                       handleOnCheckboxChange: ChangeRegister,
                                       validateInput: ChangeRegister,
                                       settingsToUpdate: SettingToUpdate[]
): EditConfigurationTableData[] => {

    return editableSetting?.map((setting) => {
        const currentValue = !isUndefinedOrNullValue(setting?.value) ? setting?.value + getUnitOfMeasure(
            setting?.um) : "-"
        return {
            info: <RegisterInfo message={setting?.notes} isVisible={setting?.notes?.length > 0}/>,
            label: setting?.label ?? "-",
            name: <p className={"font-weight-bold"}>{setting?.name ?? "-"}</p>,
            default: !isUndefinedOrNullValue(setting?.default) ? setting?.default + getUnitOfMeasure(setting?.um) : "-",
            min: setting?.min ?? "-",
            max: setting?.max ?? "-",
            lastUpdate: setting?.updatedAt ? getFormattedDate({dateToFormat: setting?.updatedAt}) : "-",
            current: <p className={"font-weight-bold"}>{currentValue}</p>,
            new: <TextInput
                key={setting?.reg}
                placeholder={setting.rw ? AppTranslations.genericWords.insertNewValue : "-"}
                onChange={handleOnTextInputChange(setting)}
                onBlur={validateInput(setting)}
                readOnly={!setting.rw}
                styles={{
                    input: {
                        boxSizing: "border-box",
                        height: 30,
                        width: 180
                    }
                }}
                endInputAddon={
                    <InputAddon position="end">
                        <span className={"unit-of-measure"}>{getUnitOfMeasure(setting?.um)}</span>
                    </InputAddon>}
            />,
            read: <Checkbox
                key={setting?.reg}
                onChange={handleOnCheckboxChange(setting)}
                checked={isChecked(setting?.reg, settingsToUpdate)}
                disabled={isDisabled(setting?.reg, settingsToUpdate)}
            />
        }
    });
}


export const createColumnsForEditingTable = (getTableHeadersName: (name: TABLES_NAMES) => string): TableColumn[] => {
    return [
        ...createColumnsForCurrentSettings(getTableHeadersName),
        createColumn(getTableHeadersName(TABLES_NAMES.NEW), TABLES_INDEXES.NEW, TABLES_INDEXES.NEW, 50),
        createColumn(getTableHeadersName(TABLES_NAMES.READ), TABLES_INDEXES.READ, TABLES_INDEXES.READ, 50, false,
            "center"),
    ];
}
